import { DefaultQueryParams } from '@frontend/api-utils';
import { ObjectSelectInputV2, ObjectSelectV2Props } from '@frontend/form';
import { CommonMessage } from '@frontend/lang';
import { SpotClient } from '@frontend/spot/api';
import { Spot, SpotsQueryParams } from '@frontend/spot/types';
import React, { useState } from 'react';

const ID = 'spot-select';
export interface SpotSelectProps extends ObjectSelectV2Props<Spot, SpotsQueryParams> {}
/**
 * @deprecated
 */
export const SpotSelect = (props: SpotSelectProps) => {
    const [v, cV] = useState<Spot | null>(null);
    return (
        <ObjectSelectInputV2<Spot, DefaultQueryParams | SpotsQueryParams>
            {...props}
            id={`${ID}${props.id && '-' + props.id}`}
            label={props.label || CommonMessage.OBJECTS.SPOT.DEFAULT}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v?.id || null);
                props.onChangeObject && props.onChangeObject(v);
                cV(v);
            }}
            required={props.required}
            queryParams={{ ...props.queryParams }}
            value={v}
            isClearable={props.isClearable}
            idValue={props.value || v?.id}
            fetch={(arg) => SpotClient.fetchSpots({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(spot) => spot.name}
            disableFetch={props.disableFetch}
            disabled={props.disabled}
            useQueryParam={
                props.allowURLChange
                    ? {
                          param: 'spot_id',
                          fetch: (id) =>
                              SpotClient.resolveSpots([id]).then((res) => {
                                  return res.results[0];
                              })
                      }
                    : undefined
            }
        />
    );
};
